/* ------ ADD TO CART ------ */
// used on PLP atc button
document.addEventListener("click", function (e) {

    const btn = e.target.closest(".add-to-cart");
    if (!btn) return; // not an add-to-cart button

    // Prevent default and stop propagation to ensure no conflicts
    e.preventDefault();
    e.stopPropagation();

    // Skip if button is disabled
    if (btn.disabled || btn.getAttribute('disabled') !== null) {
        return;
    }

    const variantId = Number(btn.getAttribute("data-variant-id"));
    const metaText = btn.getAttribute("data-variant-lineitem");

    if (!variantId || isNaN(variantId)) {
        console.error("Invalid variant ID");
        return;
    }

    const data = {
        id: variantId,
        quantity: 1,
        properties: {}
    };

    // Add metafield value as a line item property if it exists
    if (metaText && metaText.trim() !== "") {
        data.properties["ships_on"] = metaText;
    }

    // Disable button during request
    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = "Adding...";

    // Shopify AJAX add to cart
    fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    })
    .then((res) => res.json())
    .then(() => {
        // Re-enable button
        btn.disabled = false;
        btn.textContent = originalText;

        // AMP disabled on AU — open the native theme cart drawer instead of AMP_API.OPEN_CART().
        // (cart.js CartDrawer.onCartRefresh listens for this event and calls show() when open===true.)
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
    })
    .catch((error) => {
        console.error("Error adding product to cart:", error);
        btn.disabled = false;
        btn.textContent = originalText;
        alert("Sorry, there was an error adding this item to your cart. Please try again.");
    });
}, true); // Use capture phase to ensure we catch it first

/* ------ AMP CART ------ */
/* AMP DISABLED ON AU — commented out (not deleted). This global fetch override
   intercepted /cart/add.js and called AMP_API.OPEN_CART(), which is undefined
   when the Upsell by AMP app is not installed. Native theme drawer handles opening.
if (!document.body.classList.contains('collection-template')) {
  (function() {
    const originalFetch = window.fetch;
    window.fetch = async function(...args) {
      const response = await originalFetch.apply(this, args);
      const requestUrl = args[0];
      if (typeof requestUrl === 'string' && requestUrl.includes('/cart/add.js')) {
        response.clone().json().then((data) => {
          onProductAddedToCart(data);
        }).catch((err) => {
          console.error('Error reading /cart/add.js response:', err);
        });
      }
      return response;
    };
    // Define the function outside so it can be called in fetch interceptor
    function onProductAddedToCart(data) {
      AMP_API.OPEN_CART();
    }
    // Check if any div with class 'amp-cart' also has class 'amp-cart--open'
    const ampCart = document.querySelector('div.amp-cart');
  })();
}
*/

/* ------ AMP CART UPDATE FUNCTIONS ------ */
/* AMP DISABLED ON AU — commented out (not deleted). These helpers operate on
   AMP-only DOM (.amp-cart__*) and window.AMP_CART_UPDATED is invoked only by the
   Upsell by AMP app, which is not installed on AU.
  placingPriceOnButton = async () => {
    const checkoutButton = document.querySelector('.amp-cart__footer-checkout-button');
    if (!checkoutButton) return;

    const res = await fetch('/cart.js');
    const cart = await res.json();

    const subtotal = (cart.total_price / 100); // Shopify uses cents

    let subtotalSpan = checkoutButton.querySelector('.subtotalOnButton');

    if (!subtotalSpan) {
      subtotalSpan = document.createElement('span');
      subtotalSpan.classList.add('subtotalOnButton');
      checkoutButton.appendChild(subtotalSpan);
    }

    subtotalSpan.innerText = `- $${subtotal}`;
  };

  cartFooterHeight = async () => {
    const footer = document.querySelector('.amp-cart__footer');
    const upsell = document.querySelector('.amp-cart__upsell--carousel');

    if (footer && upsell) {
      const observer = new ResizeObserver(() => {
        upsell.style.bottom = `${footer.offsetHeight}px`;
      });

      observer.observe(footer);
    }
  };

window.AMP_CART_UPDATED = function(updatedCart) {
// AMP CART COUNTER UPDATE
  const cartCountEl = document.querySelector('cart-count');
  if (cartCountEl) {
    const item_count = document.querySelectorAll('.amp-cart__cart-line').length;
    // Update the inner text
    if (item_count > 99) {
      cartCountEl.innerHTML = `<span class="text-sm">99+</span>`;
      cartCountEl.classList.add('cart-count--small-medium');
    } else {
      cartCountEl.textContent = item_count;
      cartCountEl.classList.remove('cart-count--small-medium');
    }
    // Update aria-label
    cartCountEl.setAttribute('aria-label', `${item_count} item${item_count === 1 ? '' : 's'}`);
    // Show or hide the element based on count
    cartCountEl.hidden = item_count === 0;
    // Add or remove the global class on <html>
    const method = item_count === 0 ? 'remove' : 'add';
    document.documentElement.classList[method]('cart-has-items');
  }
  cartFooterHeight();
  placingPriceOnButton();
};
*/

/* ------ Header hide after Xpx, works with sections above header ------ */
document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.header-sticky');
  if (!header) return;

  // Function to get all .shopify-section elements above the header
  function getSectionsAboveHeader() {
    return Array.from(document.querySelectorAll('.shopify-section'))
      .filter(section => section.compareDocumentPosition(header) & Node.DOCUMENT_POSITION_FOLLOWING);
  }

  // Function to calculate total height of sections above header
  function calculateHeight(sections) {
    return sections.reduce((sum, section) => sum + section.clientHeight, 0);
  }

  let sectionsAboveHeader = getSectionsAboveHeader();
  let height = calculateHeight(sectionsAboveHeader);

  let lastScrollY = window.scrollY;
  let lastDirection = 0; // 1 = down, -1 = up
  let ticking = false;
  const threshold = 5; // Ignore tiny scrolls

  function updateHeader() {
    const currentScrollY = window.scrollY;

    // --- iPHONE SAFARI FIX: At top, always show header ---
    if (currentScrollY === 0) {
      header.style.marginTop = `${height}px`;
      header.style.top = `${height}px`;
      sectionsAboveHeader.forEach(sec => sec.classList.add('show__scroller'));
      header.classList.remove('header-hidden');

      lastScrollY = 0;
      lastDirection = -1;
      ticking = false;
      return;
    }
    // ------------------------------------------------------

    const diff = currentScrollY - lastScrollY;

    if (Math.abs(diff) > threshold) {
      const direction = diff > 0 ? 1 : -1;

      if (direction !== lastDirection) {
        if (direction === 1) {
          // Scrolling down → hide header
          header.classList.add('header-hidden');
          header.style.marginTop = 0;
          header.style.top  = 0;
          sectionsAboveHeader.forEach(sec => sec.classList.remove('show__scroller'));
        } else {
          // Scrolling up → show header
          header.style.marginTop = `${height}px`; 
          header.style.top = `${height}px`; 
          sectionsAboveHeader.forEach(sec => sec.classList.add('show__scroller'));
          header.classList.remove('header-hidden');
        }
        lastDirection = direction;
      }

      lastScrollY = currentScrollY;
    }

    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  });

  // Recalculate sections and height on resize
  window.addEventListener('resize', () => {
    sectionsAboveHeader = getSectionsAboveHeader();
    height = calculateHeight(sectionsAboveHeader);

    // Ensure header is correctly positioned if currently visible
    if (!header.classList.contains('header-hidden')) {
      header.style.marginTop = `${height}px`;
      header.style.top = `${height}px`;
      sectionsAboveHeader.forEach(sec => sec.classList.add('show__scroller'));
    }
  });
});


/* ------ HP VIDEO HERO ------ */
function setHeroHeight() {
  var viewportHeight = window.innerHeight;
  // Set height attribute of all <video> elements
  document.querySelectorAll('video').forEach(function(video) {
    video.setAttribute('height', viewportHeight);
  });
  // Set CSS height of all <video-element> elements
  document.querySelectorAll('video-element').forEach(function(el) {
    el.style.height = viewportHeight + 'px';
  });
  // Remove specific classes from all <motion-element> elements with class 'media'
  document.querySelectorAll('motion-element.media').forEach(function(el) {
    el.classList.remove('media', 'media--adapt', 'mb:media--adapt');
  });
}
document.addEventListener('DOMContentLoaded', function() {
  if (document.body.classList.contains('index-template')) {
    setHeroHeight();
    window.addEventListener('resize', setHeroHeight);
  }
});

/* ------ GORGIAS ------ */
  //Hide Gorgias and show on scroll
  //if (document.body.classList.contains('index-template')) {
    window.addEventListener("scroll", function () {
      const gcc = document.getElementById("gorgias-chat-container");
      if (gcc) {
        if (window.scrollY > 100) {
          gcc.style.display = "block";
        } else {
          gcc.style.display = "none";
        }
      }
    });
  //}

/* ------ FOOTER ------ */
document.addEventListener("DOMContentLoaded", function () {
  // Load AccessiBe script
  (function () {
    const s = document.createElement('script');
    const h = document.querySelector('head') || document.body;
    s.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
    s.defer = true;
    s.onload = function () {
      const initAccessiBe = () => {
        const customTrigger = document.querySelector('.acc__link');
        const realTrigger = document.querySelector('.acsb-trigger');

        if (customTrigger && typeof acsbJS === 'object' && typeof acsbJS.init === 'function') {

          acsbJS.init({
            statementLink: 'https://thebeast.com/pages/accessibility',
            hideTrigger: true,
            disableBgProcess: false,
            language: 'en',
            position: 'left',
            leadColor: '#121212',
            triggerColor: '#121212',
            triggerRadius: '50%',
            triggerPositionX: 'right',
            triggerPositionY: 'bottom',
            triggerIcon: 'people',
            triggerSize: 'medium',
            triggerOffsetX: 20,
            triggerOffsetY: 20,
            mobile: {
              triggerSize: 'small',
              triggerPositionX: 'right',
              triggerPositionY: 'bottom',
              triggerOffsetX: 10,
              triggerOffsetY: 10,
              triggerRadius: '50%'
            }
          });

          const waitForRealTrigger = setInterval(() => {
            const realTrigger = document.querySelector('.acsb-trigger');
            if (realTrigger) {
              //console.log("✅ Real AccessiBe trigger found — wiring custom click");
              realTrigger.style.display = 'none'; // hide widget
              customTrigger.addEventListener('click', function (e) {
                e.preventDefault();
                realTrigger.click();
              });
              clearInterval(waitForRealTrigger);
            }
          }, 100);

          clearInterval(waitInit);
        }
      };

      const waitInit = setInterval(initAccessiBe, 100);
    };
    h.appendChild(s);
  })();

});

/* ------ PLP ------ */
  // Script to replace the swatch click from redirect to rather display the variant image
  $('body').on('click', '.product-card__swatches ul.swatches--product-card li', function(event) {
    event.preventDefault();

    // Get the ATC button
    var atcButton = $(this).closest('.product-card').find('button.add-to-cart');
    // Get the swatch variant ID
    var variantId = $(this).data('variant-id');
    atcButton.attr('data-variant-id', variantId);
    // Get the swatch availability 
    let variantStock = $(this).data('stock');

    // Get the new image paths for primary and secondary images
    var getswatch = $(this).data('variant-img');
    var getswatchhover = $(this).data('variant-hover');
    
    // Cache the product card and images
    var $productCard = $(this).closest('.product-card');
    var $pImage = $productCard.find('.product-card__image--main img');
    var $sImage = $productCard.find('.product-card__image--second img');
    
    // Get current src and srcset for primary and secondary images
    var primarySrc = $pImage.attr('src');
    var primarySrcset = $pImage.attr('srcset');
    var secondarySrc = $sImage.attr('src');
    
    // Update the image sources
    var newPSrc = primarySrc.replace(/files\/[^?]+/, '/' + getswatch);
    var newPSrcset = primarySrcset ? primarySrcset.replace(/files\/[^?]+/g, '/' + getswatch) : null;
    var newSSrc = secondarySrc.replace(/\/([^\/]+)(\?v=[^&]+)/, '/'+ getswatchhover + '$2');

    // Set the updated src and srcset back to the images
    $pImage.attr('src', newPSrc);
    if (newPSrcset) {
      $pImage.attr('srcset', newPSrcset);
    }

    $sImage.attr('src', newSSrc);
    if (getswatchhover) {
      // Generate srcset for secondary image
      const baseSSrc = newSSrc.split('?')[0];
      const querySSrc = newSSrc.includes('?') ? newSSrc.split('?')[1] + '&' : '';
      
      const newSSrcset = `
        ${baseSSrc}?${querySSrc}width=270 270w,
        ${baseSSrc}?${querySSrc}width=450 450w,
        ${baseSSrc}?${querySSrc}width=600 600w
      `;
      
      $sImage.attr('srcset', newSSrcset.trim());
    } else {
      // If no hover image provided, fallback to primary srcset
      $sImage.attr('srcset', newPSrcset);
    }

    if(variantStock == false ) {
      atcButton.prop('disabled', true).text('Out of Stock');
    } else {
      atcButton.prop('disabled', false).text('Add to Cart');
    }
  });

/* ------ ACCESSORIES ------ */
  $(document).ready(function() {
    $('.collection-template.accessories #ProductCount').text('0 products');
    $('#acc_select').change(function() {
      let selectedOption = $('#acc_select option:selected');
      let selectedDataTag = selectedOption.data('tag');
      let selectedTitle = selectedOption.text();
  
      $('#ProductGridContainer .f-column').show();
  
      $('#ProductGridContainer .f-column').each(function() {
        let tags = $(this).attr('data-tag'); // raw string, e.g. "acc_all,acc_go,acc_mega"
        
        // Check if selectedDataTag is included
        if (!tags || !tags.includes(selectedDataTag)) {
          $(this).hide();
        }
      });
  
      let visibleCount = $('#ProductGridContainer .f-column:visible').length;
      $('.collection-template.accessories #ProductCount').text(visibleCount + ' products');

      if (selectedTitle.includes('Select')) {
        $('.accessories_title').hide();
      } else {
        $('.accessories_title').fadeIn();
        $('.accessories_title h3').text('Shop ' + selectedTitle + ' Accessories');
      }
    });
  });


/* ------ PDP ------ */

  // Bundle Switcher
  if (window.location.pathname.includes('/products/')) {
    document.addEventListener('DOMContentLoaded', () => {
      const dropdown = document.getElementById('product-bundle');
      const toggle = document.getElementById('bundle-toggle');
      const list = dropdown.querySelector('ul');
      const items = dropdown.querySelectorAll('li input[type="radio"]');

      // Handle the radio reorder behavior
      items.forEach(input => {
        input.addEventListener('click', (e) => {
          e.preventDefault();
          const link = input.parentElement.getAttribute('href');
          // Redirect after a short delay
          setTimeout(() => {
            window.location.href = link;
          }, 80);
        });
      });

      // Toggle dropdown open/close
      toggle.addEventListener('click', (e) => {
        e.stopPropagation();
        dropdown.classList.toggle('open');
      });

      // Handle dropdown item clicks (non-radio version)
      const lis = dropdown.querySelectorAll('li');
      lis.forEach(item => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          const title = item.dataset.title;
          const url = item.dataset.url;

          // Update visible label
          toggle.textContent = title;

          // Mark active
          lis.forEach(li => li.classList.remove('active_bundle'));
          item.classList.add('active_bundle');

          // Close dropdown smoothly
          dropdown.classList.remove('open');

          // Redirect after animation
          setTimeout(() => {
            window.location.href = url;
          }, 300);
        });
      });

      // Close dropdown when clicking outside
      document.addEventListener('click', (e) => {
        if (!dropdown.contains(e.target)) {
          dropdown.classList.remove('open');
        }
      });
    });
  };

// Custom notice (Ship on data)
  window.addEventListener('load', function () {
    var custom_line_item = $('.product__block--variant_picker .color_wrap input[type="radio"]:checked').attr('custom');

    // Create container if it doesn't exist
    if (!$('.product__block--line-item').length) {
      $('<div class="product__block product__block--line-item"></div>')
        .insertBefore('.product__block--buy_buttons');
    }

    // Set content and show/hide
    if (custom_line_item && custom_line_item.length >= 2) {
      $('.product__block--line-item')
        .html(custom_line_item)
        .show();
    } else {
      $('.product__block--line-item')
        .hide()
        .empty();
    }
  });

  $(document).on('change', '.product__block--variant_picker .color_wrap input[type="radio"]', function () {
    var custom_line_item = $(this).attr('custom');

    if (custom_line_item && custom_line_item.length >= 2) {
      $('.product__block--line-item')
        .html(custom_line_item)
        .show();
    } else {
      $('.product__block--line-item')
        .hide()
        .empty();
    }
  });


// Description limit height (Show/Hide)
  const maxPreviewHeight = 130;
  $('.product__block[data-block="description"] .accordion-details__content').each(function () {
    const $content = $(this);
    $content.wrap('<div class="accordion-details__content-wrapper"></div>');
    
    const $wrapper = $content.parent();
    
    if ($content[0].scrollHeight > maxPreviewHeight) {
      $wrapper.after('<span class="read-more-toggle">Show more</span>');
    }
  });

  $(document).on('click', '.read-more-toggle', function () {
    const $btn = $(this);
    const $wrapper = $btn.prev('.accordion-details__content-wrapper');
    const isExpanded = $wrapper.toggleClass('expanded').hasClass('expanded');

    $btn.text(isExpanded ? 'Show less' : 'Show more');
  });


  (function () {
  // Early exit if section isn't on this page
  if (!document.getElementById('beast-compare-blenders')) return;

  const select1 = document.getElementById('compare_1_select');
  const select2 = document.getElementById('compare_2_select');
  const select3 = document.getElementById('compare_3_select');
  const isMobile = $(window).width() <= 768;

  // Disable options already selected in other selects (desktop only)
  function updateSelectOptions() {
    if (isMobile) return;
    const vals = [select1.value, select2.value, select3.value];
    [select1, select2, select3].forEach(function (sel, i) {
      const others = vals.filter((_, j) => j !== i);
      Array.from(sel.options).forEach(function (opt) {
        opt.disabled = others.includes(opt.value);
      });
    });
  }

  // Show only selected columns, hide the rest
  function hideCompare() {
    const selv1 = select1.value;
    const selv2 = select2.value;
    const selv3 = select3.value;

    document.querySelectorAll('.beast_compare_col').forEach(function (div) {
      const id = div.getAttribute('data-prod');
      const visible = isMobile
        ? id === selv1 || id === selv2
        : id === selv1 || id === selv2 || id === selv3;
      $(div).toggle(visible);
    });
  }

  // Equalise row heights across columns
  function equaliseRows() {
    const columns = document.querySelectorAll('.beast_compare_col');
    if (!columns.length) return;

    const rows = columns[0].querySelectorAll('.grid_line').length;
    for (let i = 0; i < rows; i++) {
      const rowLines = Array.from(columns).map(col => col.querySelectorAll('.grid_line')[i]);
      const maxH = rowLines.reduce((max, line) => Math.max(max, line.offsetHeight), 0);
      rowLines.forEach(line => (line.style.height = maxH + 'px'));
    }
  }

  window.addEventListener('load', function () {
    // Show/hide section wrapper based on column count
    const colCount = document.querySelectorAll('.beast_compare_col').length;
    $('#beast_compare').addClass(colCount === 1 ? 'one_ccol' : 'two_ccol').show();

    // Set default visible images per column (first swatch)
    $('#beast_compare .cb_img').hide();
    $('.beast_compare_col').each(function () {
      const defSwatch = $('.beast_color_block:first', this).data('swatch');
      $(this).find('.cb_img').filter(function () {
        return $(this).data('color') === defSwatch;
      }).show();
      $(this).find('.beast_color_block').filter(function () {
        return $(this).data('swatch') === defSwatch;
      }).addClass('ccolur_actv');
    });

    equaliseRows();
  });

  // Color swatch click
  $(document).on('click', '.beast_color_block', function () {
    const $col = $(this).closest('.beast_compare_col');
    $col.find('.beast_color_block').removeClass('ccolur_actv');
    $(this).addClass('ccolur_actv');

    const selSwatch = $(this).data('swatch');
    $col.find('.cb_img').hide();
    $col.find('.cb_img').filter(function () {
      return $(this).data('color') && $(this).data('color').includes(selSwatch);
    }).fadeIn();
  });

  $(document).ready(function () {
    // Set default selected options
    $('#compare_1_select option:eq(0)').prop('selected', true);
    $('#compare_2_select option:eq(1)').prop('selected', true);

    if (isMobile) {
      $('#compare_3_select').hide();
      // Cross-disable on mobile
      $('#compare_2_select option[value="' + select1.value + '"]').prop('disabled', true);
      $('#compare_1_select option[value="' + select2.value + '"]').prop('disabled', true);
    } else {
      $('#compare_3_select option:eq(2)').prop('selected', true);
    }

    updateSelectOptions();
    hideCompare();

    // Change handlers — parameterised to avoid repetition
    function makeChangeHandler(sel, order, otherSelects) {
      $(sel).on('change', function () {
        hideCompare();
        const val = $(this).val();
        $('.beast_compare_col[data-prod="' + val + '"]').css('order', order).show();

        if (isMobile) {
          // Re-enable all then disable the newly selected value in the other select
          otherSelects.forEach(function (other) {
            $(other).find('option').prop('disabled', false);
            $(other).find('option[value="' + val + '"]').prop('disabled', true);
          });
        } else {
          updateSelectOptions();
        }
      });
    }

    makeChangeHandler(select1, 0, [select2]);
    makeChangeHandler(select2, 1, [select1]);
    if (!isMobile) makeChangeHandler(select3, 2, []);

    select1.addEventListener('change', updateSelectOptions);
    select2.addEventListener('change', updateSelectOptions);
    select3.addEventListener('change', updateSelectOptions);
  });
})();

// Fix for cart drawer scroll issue - Direct MutationObserver approach
// The theme's modal system leaves modal-showing class on body, preventing scroll

function logScrollState(label) {
  console.log(`[ScrollFix] ${label}`, {
    modalShow: document.body.classList.contains('modal-show'),
    modalShowing: document.body.classList.contains('modal-showing'),
    overflow: getComputedStyle(document.body).overflow,
    bodyStyleOverflow: document.body.style.overflow,
    bodyClasses: document.body.className
  });
}

function restoreBodyScroll() {
  console.trace('[ScrollFix] restoreBodyScroll called from:');

  logScrollState('BEFORE cleanup');

  // Remove all scroll-locking classes (theme and Rebuy)
  document.body.classList.remove('modal-show', 'modal-showing', 'rebuy-cart-visible');
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';

  // Fix site-wrapper overflow clip issue
  const siteWrapper = document.querySelector('.site-wrapper');
  if (siteWrapper) {
    siteWrapper.style.overflow = 'visible';
  }

  logScrollState('IMMEDIATELY after cleanup');

  setTimeout(() => logScrollState('100ms after cleanup'), 100);
  setTimeout(() => logScrollState('500ms after cleanup'), 500);
}

// Primary fix: Watch for cart drawer state changes
const cartObserver = new MutationObserver(function(mutations) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  const isOpen = cartDrawer.hasAttribute('open');
  const hasModalClass = document.body.classList.contains('modal-showing') ||
                        document.body.classList.contains('modal-show');

  // If cart is closed but modal classes exist, remove them
  if (!isOpen && hasModalClass) {
    console.log('[ScrollFix] Cart closed, removing modal classes');
    restoreBodyScroll();
  }
});

// Start observing when cart drawer exists
document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['open'] });
    console.log('[ScrollFix] Monitoring cart drawer');
  }
});

// Backup: Also watch body classes directly
const bodyObserver = new MutationObserver(function(mutations) {
  const cartDrawer = document.querySelector('cart-drawer');
  const isCartOpen = cartDrawer && cartDrawer.hasAttribute('open');
  const hasModalClass = document.body.classList.contains('modal-showing') ||
                        document.body.classList.contains('modal-show');

  // If modal classes exist but cart is not open, remove them after a brief delay
  if (hasModalClass && !isCartOpen) {
    setTimeout(function() {
      const stillClosed = !document.querySelector('cart-drawer[open]');
      if (stillClosed) {
        console.log('[ScrollFix] Body has modal classes but cart is closed');
        restoreBodyScroll();
      }
    }, 300);
  }
});

bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

// Additional event listeners as backup
document.addEventListener('rebuy:cart.hide', restoreBodyScroll);
document.addEventListener('cart:close', restoreBodyScroll);
document.addEventListener('drawer:handleAfterHide', function() {
  setTimeout(restoreBodyScroll, 100);
});

/* ------ OKENDO QUIZ T&C & PRIVACY POLICY URL OVERRIDE ------ */
(function() {
  const beastQuizContainer = document.querySelector('.beast-quiz');
  if (!beastQuizContainer) return; // Exit if quiz container doesn't exist

  // Configuration: Market-specific URLs
  const marketCountry = window.ShopifyMarketCountry || 'AU';
  const domain = marketCountry === 'NZ' ? 'beasthealth.co.nz' : 'beasthealth.com.au';
  const NEW_TERMS_URL = `https://${domain}/pages/terms-of-service`;
  const NEW_PRIVACY_URL = `https://${domain}/pages/privacy-policy`;

  const MAX_ATTEMPTS = 50; // Stop trying after 50 mutations (prevents infinite loops)
  let attempts = 0;
  let termsFound = false;
  let privacyFound = false;

  // Function to find and update the Terms & Conditions and Privacy Policy links
  function updatePolicyLinks() {
    let updated = false;

    // Find all anchor tags within the quiz container
    const links = beastQuizContainer.querySelectorAll('a');

    for (let link of links) {
      const href = link.getAttribute('href') || '';
      const text = link.textContent.toLowerCase();

      // Update Terms & Conditions link
      if (!termsFound &&
          ((href.includes('terms') || text.includes('terms')) &&
           !text.includes('privacy'))) {
        console.log('[Okendo Quiz] Found T&C link:', href);
        link.setAttribute('href', NEW_TERMS_URL);
        console.log('[Okendo Quiz] Updated T&C URL to:', NEW_TERMS_URL);
        termsFound = true;
        updated = true;
      }

      // Update Privacy Policy link
      if (!privacyFound &&
          (href.includes('privacy') || text.includes('privacy'))) {
        console.log('[Okendo Quiz] Found Privacy Policy link:', href);
        link.setAttribute('href', NEW_PRIVACY_URL);
        console.log('[Okendo Quiz] Updated Privacy Policy URL to:', NEW_PRIVACY_URL);
        privacyFound = true;
        updated = true;
      }

      // Stop if both links found
      if (termsFound && privacyFound) {
        return true;
      }
    }

    return termsFound && privacyFound;
  }

  // Initial check (in case quiz is already loaded)
  if (updatePolicyLinks()) {
    console.log('[Okendo Quiz] Policy links found on initial check');
    return; // Exit early, no need to observe
  }

  // Set up MutationObserver to watch for dynamic content
  const observer = new MutationObserver(function(mutations) {
    attempts++;

    if (updatePolicyLinks()) {
      console.log('[Okendo Quiz] Policy links updated, disconnecting observer');
      observer.disconnect(); // Stop observing once links are updated
    } else if (attempts >= MAX_ATTEMPTS) {
      console.warn('[Okendo Quiz] Max attempts reached, stopping observer');
      observer.disconnect(); // Prevent infinite observation
    }
  });

  // Start observing the quiz container for changes
  observer.observe(beastQuizContainer, {
    childList: true,      // Watch for added/removed child nodes
    subtree: true,        // Watch all descendants, not just direct children
    attributes: false     // Don't watch attribute changes (we only care about new elements)
  });

  console.log('[Okendo Quiz] Monitoring for Terms & Conditions and Privacy Policy links...');
})();